import { SIDEMENU_MODE } from 'e3-common/constants/enumerates';

import { useBoundStore } from 'e3-common/store/useBoundStore';
import styles from './SideMenu.module.css';
import { shallow } from 'zustand/shallow';
import PropTypes from 'prop-types';

const SideMenuFavoriteTab = ({ sideMenuMode, onMenuClick }) => {
    const { favoriteMenu } = useBoundStore((state) => state.menu, shallow);

    const createFilterMenu = (flatMenuList, txt) => {
        if (!flatMenuList || flatMenuList?.length === 0) return;

        return flatMenuList
            ?.filter((f) => {
                if (!f.programRoutePath) return null;
                if (!txt) return f;
                if (f.menuName.includes(txt)) return f;
                return null;
            })
            .map((e) => {
                return (
                    <li
                        className={styles.menuSearchList}
                        key={e.menuId}
                        //className={addStyle(e)}
                        onClick={() => {
                            onMenuClick(e);
                            //onHandleList(e.children.length > 0 && e.menuId);
                        }}
                    >
                        {e.menuName}
                    </li>
                );
            });
    };
    return (
        <div
            className={styles.inner}
            style={{
                display: sideMenuMode === SIDEMENU_MODE.FAVORITE ? 'block' : 'none',
            }}
        >
            <h2>메뉴 즐겨찾기</h2>
            <ul>{createFilterMenu(favoriteMenu, '')}</ul>
        </div>
    );
};

SideMenuFavoriteTab.propTypes = {
    sideMenuMode: PropTypes.string,
    onMenuClick: PropTypes.func,
};
SideMenuFavoriteTab.displayName = 'SideMenuFavoriteTab';
export default SideMenuFavoriteTab;
